<template>
  <v-toolbar color="primary" fixed dark flat class="app-header">
    <v-app-bar-nav-icon @click="handleDrawerToggle"></v-app-bar-nav-icon>
    <v-toolbar-title class="app-header__title d-none d-sm-block">Transport App</v-toolbar-title>

    <v-spacer></v-spacer>

    <v-text-field
      v-model="searchtext"
      :label="$t('toobar.search')"
      prepend-inner-icon="search"
      solo-inverted
      flat
      dense
      hide-details
      clearable
      class="app-header__search"
    ></v-text-field>

    <v-spacer></v-spacer>

    <v-btn icon @click="handleFullScreen()" title="Pełny ekran">
      <v-icon>fullscreen</v-icon>
    </v-btn>
    <v-btn icon @click="handleLogout" title="Wyloguj">
      <v-icon>logout</v-icon>
    </v-btn>
  </v-toolbar>
</template>
<script>
import Util from "@/util"
export default {
  name: "AppToolbar",
  components: {
  },
  data() {
    return {
      searchtext:null,
    }
  },
  computed: {
    toolbarColor() {
      return this.$vuetify.options.extra.mainNav
    }
  },
  watch:{
    searchtext(value){
      this.store.state.searchtext = this.searchtext;
    }
  },
  methods: {
    handleDrawerToggle() {
      this.$emit("side-icon-click")
    },
    handleFullScreen() {
      Util.toggleFullScreen()
    },
    delete_cookie( name ) {
      document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    },
    handleLogout() {
      //handle logout
      this.delete_cookie("jwt");
      this.$router.push('/auth/login')
    },
    handleSetting() {

    },
    handleProfile() {

    }
  }
}
</script>

<style scoped lang="css">
.app-header__title { font-size: 18px; font-weight: 700; letter-spacing: -.2px; }
.app-header__search { max-width: 360px; }
.app-header__search >>> .v-input__slot {
  background: rgba(255, 255, 255, .16) !important;
  border-radius: 12px !important;
  box-shadow: none !important;
  min-height: 42px;
}
.app-header__search >>> input { color: #fff; }
.app-header__search >>> .v-label { color: rgba(255, 255, 255, .82); }
.app-header__search >>> .v-icon { color: rgba(255, 255, 255, .9); }
.app-header__search >>> .v-input__icon--clear .v-icon { color: rgba(255, 255, 255, .7); }
</style>
